// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__d1xIZ"};